export default {
    COMMISSION_DETAILS_REQUEST: 'APP/COMMISSION_DETAILS/COMMISSION_DETAILS_REQUEST',
    COMMISSION_DETAILS_SUCCESS: 'APP/COMMISSION_DETAILS/COMMISSION_DETAILS_SUCCESS',
    COMMISSION_DETAILS_ERROR: 'APP/COMMISSION_DETAILS/COMMISSION_DETAILS_ERROR',
  };
  